<template>
  <div id="app">
    <NotificationRenew :message="notification.message" :type="notification.type" v-if="notification.show" />
    <div class="row">
      <div class="col-12">
        <h2 class="generalTitle">Renovaciones</h2>
      </div>
    </div>



    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="filter($event)" :filterURL="filterURL" :isLoading="loading" />
      </div>


      <div class="progress-renew col-12 mb-3" v-if="loading">
        <div class="progress-bar-renew" style="width: 100%;"></div>
      </div>

      <div class="col-12" v-else-if="!loading && renews.length === 0">
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>

      <div class="col-12" v-else>
        <div v-if="renews && renews.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="align-items-center d-flex justify-content-between mb-1">
              <p class="mb-2">Mostrando {{from}}-{{to}} de {{totalItems}} renovaciones</p>
            </div>
            <list :renews="renews" @selectOrder="selectOrder($event)" @reloadList="handleReloadListRequest" @notify="handleNotify" />


            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage"
                      @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Renovaciones por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>





    </div>
  </div>
</template>

<script>

import axios from 'axios';
import List from './templates/List.vue';
import ListFilters from '@/components/Widgets/Shared/RenewsListFilters.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
import NotificationRenew from '@/components/Widgets/Shared/NotificationRenew.vue';
import { useRoute } from 'vue-router';

export default {
  name: 'RenewsList',
  data() {
    return {
      loading: false,
      progressLoading: false,
      documentNumber: '',
      shop: '',
      contractNumber: '',
      parentContractId: '',
      fromDate: '',
      toDate: '',
      status: '',
      renews: [],
      errorMessage: '',
      filters: '',
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: '',
      filtros: {
        contractId: null,
        email: null,
        legalIdentifier: null,
        date: null,
        dateFrom: null,
        dateTo: null,
        endDate: null,
        merchant: null,
        status: null
      },
      filterURL: '',
      notification: {
        message: '',
        type: '',
        show: false,
      },
    };
  },
  components: {
    List,
    ListFilters,
    Pagination,
    NotificationRenew,
  },
  created() {
    const route = useRoute();
    const filterURL = route.query.filterURL;
    if(filterURL && filterURL !== '') {
      this.filterURL = filterURL;
    } else {
      this.loadContracts();
    }
  },
  methods: {
    filter(value) {
      this.documentNumber = value.documentNumber !== undefined ? value.documentNumber : this.documentNumber;
      this.contractNumber = value.contractNumber !== undefined ? value.contractNumber : this.contractNumber;
      this.parentContractId = value.parentContractId !== undefined ? value.parentContractId : this.parentContractId;
      this.fromDate = value.from !== undefined ? value.from : this.fromDate;
      this.toDate = value.to !== undefined ? value.to : this.toDate;
      this.status = value.status !== undefined ? value.status : this.status;
      this.currentPage = 0;
      this.loadContracts();
    },
    filterDocumentNumber() {
      if (this.documentNumber !== '' && this.documentNumber !== undefined) {
        this.filters = `${this.filters}&legalIdentifier=${this.documentNumber}`;
        this.filtros.legalIdentifier = this.documentNumber
      }
    },
    filterContractNumber() {
      if (this.contractNumber !== '' && this.contractNumber !== undefined) {
        this.filters = `${this.filters}&newContractId=${this.contractNumber}`;
        this.filtros.contractId = this.contractNumber
      }
    },
    filterParentContractNumber() {
      if (this.parentContractId !== '' && this.parentContractId !== undefined) {
        this.filters = `${this.filters}&parentContractId=${this.parentContractId}`;
        this.filtros.contractId = this.parentContractId
      }
    },
    filterFrom() {
      if (this.fromDate !== '' && this.fromDate !== undefined) {
        this.filters = `${this.filters}&dateFrom=${this.$dateFrontToBack(this.fromDate)}`;
        this.filtros.dateFrom = this.fromDate
      }
    },
    filterTo() {
      if (this.toDate !== '' && this.to !== undefined) {
        this.filters = `${this.filters}&dateTo=${this.$dateFrontToBack(this.toDate)}`;
        this.filtros.dateTo = this.toDate
      }
    },
    filterStatus() {
      if (this.status !== '' && this.to !== undefined) {
        this.filters = `${this.filters}&status=${this.status}`;
        if (this.status == 'DENIED') this.filters = `${this.filters}&status=DENIED_BY_STOCKOUT`;
        this.filtros.status = this.status
      }
    },
    filterPagination() {
      this.filters = `${this.filters}pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}page=${parseInt(this.currentPage + 1)}`;
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadContracts();
    },
    selectOrder(value) {
      console.log(value);
      //Rellenar con el order cuando sepamos el formato
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.loadContracts();
    },
    async loadContracts() {
      this.loading = true;
      this.progressLoading = true;
      this.filters = '';
      console.log('Inicio ' + this.filters)
      this.filterPagination();
      console.log('Pagination ' + this.filters)
      this.filterDocumentNumber();
      this.filterContractNumber();
      this.filterParentContractNumber();
      this.filterFrom();
      this.filterTo();
      this.filterStatus()

      console.log('Fin ' + this.filters)

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }


      try {
        // Hacemos la petición al backend con los filtros aplicados
        const response = await axios.get(`/contract-renewal/search${this.filters}`);
        const renewals = response.data.renewals || [];
        this.renews = renewals.slice().sort((a, b) => {
          const dateA = new Date(a.dateOfRequest).getTime() || 0;
          const dateB = new Date(b.dateOfRequest).getTime() || 0;
          return dateB - dateA;
        });
        this.totalItems = response.data.totalElements || 0;
        this.numberPages = Math.ceil(this.totalItems / this.itemsPerPage);

        this.from = (this.currentPage * this.itemsPerPage) + 1;
        this.to = (this.currentPage * this.itemsPerPage) + this.itemsPerPage > this.totalItems
            ? this.totalItems
            : (this.currentPage * this.itemsPerPage) + this.itemsPerPage;
      } catch (error) {
        console.error("Error al obtener las renovaciones:", error);
        this.renews = [];
      } finally {
        this.loading = false;
        this.progressLoading = false;
      }
    },
    handleNotify({ message, type }) {
      this.notification.message = message;
      this.notification.type = type;
      this.notification.show = true;
      setTimeout(() => {
        this.notification.show = false;
      }, 3000);
    },
    handleReloadListRequest(payload) {
      this.loadContracts();
      if (payload && payload.delayedRefetch) {
        setTimeout(() => {
          this.loadContracts();
        }, payload.delayedRefetch);
      }
    },
  },
};

</script>

<style lang="scss">


.progress-renew {
  width: 100%;
  height: 4px!important;
  background-color: #fbfbfb;
  position: relative;
  margin-bottom: 2px;
  overflow: hidden; /* Asegura que la barra no se salga del contenedor */
}

.progress-bar-renew {
  height: 100%;
  background-color: #97055D;
  position: absolute;
  left: 0;
  animation: grow 2s linear infinite; /* Ajustamos la animación */
}

@keyframes grow {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

</style>
